module.exports = __webpack_public_path__ + "img/c00_buildingtechbroadheadarrows_Normal_ua.10641697.webp";